import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      const { fallback, tabName } = this.props;
      if (fallback) return fallback(this.state.error, () => this.setState({ error: null }));
      return (
        <div className="error-boundary-card">
          <div className="error-boundary-icon">⚠️</div>
          <h3 className="error-boundary-title">Something went wrong{tabName ? ` in ${tabName}` : ''}</h3>
          <p className="error-boundary-msg">{this.state.error.message}</p>
          <button
            className="btn btn-primary"
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
